import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { fontMerriweather } from "@product/scmp-sdk";

import { BaseImage } from "~/components/common/base-image";
import { EntityLink } from "~/components/entity-link";

export const StyledEntityLink = styled(EntityLink)`
  inline-size: 100%;
`;

export const StyledBaseImage = styled(BaseImage)`
  aspect-ratio: 4 / 3;
`;

export const ImageContainer = styled.div`
  grid-area: mainImage;
`;

export const Headline = styled.div`
  grid-area: headline;

  max-block-size: 88px;
  margin-block: 12px;
  margin-inline: 0;

  color: #000000;
  font-weight: 900;
  font-size: 16px;
  font-family: ${fontMerriweather};
  line-height: 22px;
  text-overflow: ellipsis;

  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  line-clamp: 4;
`;

export const DateContainer = styled.div`
  grid-area: date;

  color: #999999;
  font-size: 12px;
`;

export type ContainerProps = {
  $size?: "large" | "normal";
};

export const Container = styled.div<ContainerProps>`
  display: grid;
  grid:
    "mainImage" min-content
    "headline" min-content
    "date" min-content / 100%;

  ${props => props.theme.breakpoints.only("mobile")} {
    padding-block: 16px;
    border-block-end: 1px solid #dddddd;
  }

  ${props => props.$size === "normal" && props.theme.breakpoints.only("mobile")} {
    grid:
      "headline mainImage" min-content
      "date mainImage" min-content / calc(100% - 72px) 72px;

    ${Headline} {
      margin: 0;
      margin-inline-end: 16px;
    }

    ${ImageContainer}, ${StyledBaseImage} {
      inline-size: 72px;
      block-size: 72px;
    }

    ${DateContainer} {
      margin-block-start: 12px;
    }
  }

  ${props => {
    if (props.$size === "large") {
      return css`
        ${Headline} {
          max-block-size: 112px;

          font-size: 20px;
          line-height: 28px;
        }
      `;
    }
  }};
`;
